<template>
  <div class="footer">
      <b-container fluid>
            <b-row class="justify-content-lg-center flex-column flex-lg-row align-items-center">
                <div class="d-flex align-items-center footer-content">
                  <div class="footer-items">
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_MOC.png')"
                        fluid
                        style="width: 180px;"
                        alt=""
                      ></b-img>
                  </div>
                  <div class="footer-items">
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_BOCH.png')"
                        fluid
                        style="width: 320px;"
                        alt=""
                      ></b-img>
                  </div>
                </div>

                <!-- <div class="footer-items d-flex align-items-center">
                  <div>{{ $t("footer_03") }} /</div>
                  <div class="">
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_Taiwan.png')"
                        fluid
                        style="width: 240px;"
                        alt=""
                      ></b-img>
                  </div>
                  <div class="">
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_Forest.png')"
                        fluid
                        style="width: 240px;"
                        alt=""
                      ></b-img>
                  </div>
                  <div class="">
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_Forest_Chiayi.png')"
                        fluid
                        style="width: 310px;"
                        alt=""
                      ></b-img>
                  </div>
                  <div>
                      <b-img
                        :src="require('@/assets/imgs/footer_logo_AFRCH.png')"
                        fluid
                        style="width: 300px;"
                        alt=""
                      ></b-img>
                  </div>
                </div> -->

                <div class="footer-items d-flex align-items-center">
                   <div>{{ $t("footer_04") }} /</div>       
                    <b-img
                      :src="require('@/assets/imgs/footer_logo_UREF.png')"
                      fluid
                      style="width: 250px;"
                      alt=""
                    ></b-img>
                </div>

        </b-row>

      </b-container>
  </div>
</template>

<script>
  export default {
    name: "Footer",
    data() {
      return {
        visitCount: null,
        updateTime: "2022/11/22",
      };
    },
    watch: {},
    mounted() {},
    methods: {},
  };
</script>

<style lang="scss">

</style>
